/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactDatePicker from "react-datepicker";
import Input from "../../Builder/nodes/Logic/Inputs/Input";
import MyPagination from "../../Common/MyPagination";
import {
  faAngleLeft,
  faAngleRight,
  faAnglesLeft,
  faAnglesRight,
  faMagnifyingGlassMinus,
  faMagnifyingGlassPlus,
  faRotateLeft,
} from "@fortawesome/free-solid-svg-icons";
import { faClock } from "@fortawesome/free-regular-svg-icons";
import { Form } from "react-bootstrap";
import NoDataPlaceholder from "../../Common/NoDataPlaceholder";

export default function Timeline({ title, loader, processes, total, link }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [status, setStatus] = useState("");
  const [resetPagination, setResetPagination] = useState(Date.now());

  const zoomLevels = [
    { label: "1 week", time: 7 * 24 * 3600000 },
    { label: "2 days", time: 48 * 3600000 },
    { label: "24 hours", time: 24 * 3600000 },
    { label: "8 hours", time: 8 * 3600000 },
    { label: "1 hour", time: 3600000 },
    { label: "10 min", time: 600000 },
  ];
  const zoom = Number(searchParams.get("zoom") || 4);
  const zoomLevel = zoomLevels[zoom];
  const endAt = searchParams.get("end_at")
    ? new Date(searchParams.get("end_at"))
    : new Date();
  const startAt = searchParams.get("start_at")
    ? new Date(searchParams.get("start_at"))
    : new Date(endAt.getTime() - zoomLevel.time);

  const startAtTimestamp = new Date(startAt).getTime();
  const endAtTimestamp = new Date(endAt).getTime();
  const panAmount = (endAtTimestamp - startAtTimestamp) / 10;
  const scale = 100 / (endAtTimestamp - startAtTimestamp);
  const progressHeight = 30;

  // load processes
  useEffect(() => {
    setResetPagination(Date.now());
    // loader(startAt, endAt, offset, status);
  }, [searchParams, status]);

  return (
    <div className="">
      <div className="row justify-content-between align-items-end g-2 bg-colored-reverse p-3 mb-3 rounded-3 mx-0">
        <div className="col-auto d-flex align-items-center">
          <div className="fs-4 text-white fw-bold">{title}</div>
          <button
            type="button"
            title="refresh"
            className="btn btn-link p-0 ms-3"
            onClick={() => setResetPagination(Date.now())}
          >
            <FontAwesomeIcon className="text-white" icon={faRotateLeft} />
          </button>
          <div className="div d-inline-block ms-3">
            <span className="fw-bold text-white">Status:</span>
            <Input
              inputType="select"
              value={[status]}
              onChange={(values) => setStatus(values[0])}
              options={[
                { value: "", label: "Show all processes" },
                { value: "active", label: "Show active processes" },
                { value: "inactive", label: "Show inactive processes" },
              ]}
            />
          </div>
        </div>
        <div className="col-12 col-lg-auto ">
          <div className="row g-2 justify-content-center">
            <div className="col-auto d-flex">
              <button
                title="Pan view by 50%"
                type="button"
                className="btn btn-link border-0 ms-1"
                onClick={() =>
                  setSearchParams({
                    end_at: new Date(
                      endAtTimestamp - panAmount * 5
                    ).toISOString(),
                    ...(searchParams.get("start_at")
                      ? {
                          start_at: new Date(
                            startAtTimestamp - panAmount * 5
                          ).toISOString(),
                        }
                      : {}),
                    ...(searchParams.get("zoom") ? { zoom } : {}),
                  })
                }
              >
                <FontAwesomeIcon className="text-white" icon={faAnglesLeft} />
              </button>
              <button
                title="Pan view by 10%"
                type="button"
                className="btn btn-link ms-1 border-0"
                onClick={() =>
                  setSearchParams({
                    end_at: new Date(endAtTimestamp - panAmount).toISOString(),
                    ...(searchParams.get("start_at")
                      ? {
                          start_at: new Date(
                            startAtTimestamp - panAmount
                          ).toISOString(),
                        }
                      : {}),
                    ...(searchParams.get("zoom") ? { zoom } : {}),
                  })
                }
              >
                <FontAwesomeIcon className="text-white" icon={faAngleLeft} />
              </button>
              <ReactDatePicker
                className="form-control border border-primary-subtle text-secondary ms-1"
                showTimeSelect
                selected={startAt}
                dateFormat="yyyy-MM-dd HH:mm:ss"
                onChange={(date) =>
                  // when start date is custom, remove zoom
                  setSearchParams({
                    start_at: date.toISOString(),
                    end_at: endAt.toISOString(),
                  })
                }
              />
            </div>
            <div className="col-auto d-flex">
              <div className="input-group">
                <button
                  type="button"
                  className="btn btn-link border-primary-subtle"
                  disabled={zoom === 0}
                  onClick={() => {
                    if (zoom > 0) {
                      setSearchParams({
                        end_at: endAt.toISOString(),
                        zoom: zoom - 1,
                      });
                    }
                  }}
                >
                  <FontAwesomeIcon
                    className="text-white"
                    icon={faMagnifyingGlassMinus}
                  />
                </button>

                <select
                  className="form-select border-primary-subtle text-secondary"
                  value={searchParams.has("start_at") ? "custom" : zoom}
                  onChange={(e) =>
                    setSearchParams({
                      end_at: endAt.toISOString(),
                      zoom: e.target.value,
                    })
                  }
                >
                  <option value="custom" hidden>
                    Custom range
                  </option>
                  {zoomLevels.map((z, i) => (
                    <option key={i} value={i}>
                      {z.label}
                    </option>
                  ))}
                </select>

                <button
                  type="button"
                  className="btn btn-link border-primary-subtle"
                  disabled={zoom === 5}
                  onClick={() => {
                    if (zoom < 5) {
                      setSearchParams({
                        end_at: endAt.toISOString(),
                        zoom: zoom + 1,
                      });
                    }
                  }}
                >
                  <FontAwesomeIcon
                    className="text-white"
                    icon={faMagnifyingGlassPlus}
                  />
                </button>
              </div>
            </div>
            <div className="col-auto d-flex">
              <ReactDatePicker
                className="form-control border border-secondary-subtle text-secondary"
                showTimeSelect
                selected={endAt}
                dateFormat="yyyy-MM-dd HH:mm:ss"
                onChange={(date) =>
                  setSearchParams({
                    end_at: date.toISOString(),
                    ...(searchParams.get("start_at")
                      ? { start_at: searchParams.get("start_at") }
                      : {}),
                    ...(searchParams.get("zoom") ? { zoom } : {}),
                  })
                }
              />
              <button
                title="Pan view by 10%"
                type="button"
                className="btn btn-link ms-1 border-0"
                onClick={() =>
                  setSearchParams({
                    end_at: new Date(endAtTimestamp + panAmount).toISOString(),
                    ...(searchParams.get("start_at")
                      ? {
                          start_at: new Date(
                            startAtTimestamp + panAmount
                          ).toISOString(),
                        }
                      : {}),
                    ...(searchParams.get("zoom") ? { zoom } : {}),
                  })
                }
              >
                <FontAwesomeIcon className="text-white" icon={faAngleRight} />
              </button>
              <button
                type="button"
                title="Pan view by 50%"
                className="btn btn-link ms-1 border-0"
                onClick={() =>
                  setSearchParams({
                    end_at: new Date(
                      endAtTimestamp + panAmount * 5
                    ).toISOString(),
                    ...(searchParams.get("start_at")
                      ? {
                          start_at: new Date(
                            startAtTimestamp + panAmount * 5
                          ).toISOString(),
                        }
                      : {}),
                    ...(searchParams.get("zoom") ? { zoom } : {}),
                  })
                }
              >
                <FontAwesomeIcon className="text-white" icon={faAnglesRight} />
              </button>
              <button
                type="button"
                title="Go to now"
                className="btn btn-link ms-1 border-0"
                onClick={() =>
                  setSearchParams({
                    end_at: new Date().toISOString(),
                    ...(searchParams.get("start_at")
                      ? {
                          start_at: new Date(
                            startAtTimestamp + panAmount * 5
                          ).toISOString(),
                        }
                      : {}),
                    ...(searchParams.get("zoom") ? { zoom } : {}),
                  })
                }
              >
                <FontAwesomeIcon className="text-white" icon={faClock} />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white p-3 mb-5 rounded-3">
        <table className="table">
          <tbody>
            {processes.map((p) => (
              <tr key={p.ID}>
                <td className="p-0">
                  <table className="table table-borderless table-bg-transparent py-3">
                    <tbody>
                      <tr>
                        <td>
                          <div
                            style={{ minWidth: `${80}px` }}
                            className="text-secondary small bg-transparent"
                          >
                            {" "}
                            Status{" "}
                          </div>
                          {p.IsActive ? (
                            <div className="badge text-bg-success">Active</div>
                          ) : (
                            <div className="badge text-bg-secondary">
                              Completed
                            </div>
                          )}
                        </td>
                        {link(p, () => setResetPagination(Date.now()))}
                        <td>
                          <div className="text-secondary small bg-transparent">
                            {" "}
                            Start{" "}
                          </div>
                          <span className="bg-transparent">
                            {new Date(p.StartAt).toLocaleString()}
                          </span>
                        </td>
                        <td>
                          {p.IsActive ? (
                            <>
                              <div className="text-secondary small bg-transparent">
                                Maximum milestone
                              </div>
                              <span className="bg-transparent">
                                {new Date(p.MaxMilestone.Time).toLocaleString()}
                              </span>
                            </>
                          ) : (
                            <>
                              <div className="text-secondary small bg-transparent">
                                End
                              </div>
                              <span className="bg-transparent">
                                {new Date(p.EndAt.Time).toLocaleString()}
                              </span>
                            </>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={6}>
                          <div
                            className="progress-stacked mt-1 bg-tertiary "
                            style={{ height: progressHeight }}
                          >
                            <div
                              className="progress"
                              role="progressbar"
                              style={{
                                height: progressHeight,
                                width: `${
                                  (Math.max(
                                    new Date(p.StartAt).getTime(),
                                    startAtTimestamp
                                  ) -
                                    startAtTimestamp) *
                                  scale
                                }%`,
                              }}
                            >
                              <div className="progress-bar bg-transparent" />
                            </div>
                            <div
                              className="progress"
                              role="progressbar"
                              style={{
                                height: progressHeight,
                                width: `max(${
                                  (Math.max(
                                    startAtTimestamp,
                                    Math.min(
                                      p.IsActive
                                        ? new Date().getTime()
                                        : new Date(p.EndAt.Time).getTime(),
                                      endAtTimestamp
                                    )
                                  ) -
                                    Math.min(
                                      endAtTimestamp,
                                      Math.max(
                                        new Date(p.StartAt).getTime(),
                                        startAtTimestamp
                                      )
                                    )) *
                                  scale
                                }%, 3px)`,
                              }}
                            >
                              <div
                                title={`Start: ${new Date(
                                  p.StartAt
                                ).toLocaleString()} End: ${new Date(
                                  p.IsActive
                                    ? p.MaxMilestone.Time
                                    : p.EndAt.Time
                                ).toLocaleString()} `}
                                className={`progress-bar ${
                                  p.IsActive ? "bg-success" : "bg-secondary"
                                }`}
                              />
                            </div>
                            {p.IsActive && (
                              <div
                                className="progress"
                                role="progressbar"
                                style={{
                                  height: progressHeight,
                                  width: `${
                                    (Math.max(
                                      startAtTimestamp,
                                      Math.min(
                                        new Date(p.MaxMilestone.Time).getTime(),
                                        endAtTimestamp
                                      )
                                    ) -
                                      Math.min(
                                        endAtTimestamp,
                                        Math.max(
                                          new Date().getTime(),
                                          startAtTimestamp
                                        )
                                      )) *
                                    scale
                                  }%`,
                                }}
                              >
                                <div
                                  title={`Start: ${new Date(
                                    p.StartAt
                                  ).toLocaleString()} End: ${new Date(
                                    p.MaxMilestone.Time
                                  ).toLocaleString()} `}
                                  className="progress-bar bg-success bg-opacity-50"
                                />
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <MyPagination
          total={total}
          onPaginate={(page, perPage) =>
            loader(startAt, endAt, status, page * perPage, perPage)
          }
          key={resetPagination}
        />
        {processes.length === 0 && <NoDataPlaceholder />}
      </div>
    </div>
  );
}
